//MDN "The KeyboardEvent interface's key read-only property
//returns the value of the key pressed by the user,
//taking into consideration the state of modifier keys
//such as Shift as well as the keyboard locale and layout."
//We should use event.key when we care about the semantics of the operation,
//the meaning of the key and not where it is placed on the keyboard.
//The string value of the event.key for the Non-printable character keys stay consistent
//across different keyboard layouts
//Keys
export const ARROW_DOWN_KEY = 'ArrowDown';
export const ARROW_LEFT_KEY = 'ArrowLeft';
export const ARROW_RIGHT_KEY = 'ArrowRight';
export const ARROW_UP_KEY = 'ArrowUp';
export const BACKSPACE_KEY = 'Backspace';
export const COMMA_KEY = ',';
export const DELETE_KEY = 'Delete';
export const END_KEY = 'End';
export const ENTER_KEY = 'Enter';
export const ESCAPE_KEY = 'Escape';
export const HOME_KEY = 'Home';
export const PERIOD_KEY = '.';
export const SPACE_KEY = ' ';
export const TAB_KEY = 'Tab';
//MDN "The KeyboardEvent.code property represents a physical key on the keyboard
//(as opposed to the character generated by pressing the key).
//In other words, this property returns a value that isn't altered
//by keyboard layout or the state of the modifier keys."
//We should use event.code when we care about the physical placement of the key on the keyboard.
//Event.code is better used for widely known shortcuts,
//because the event.code property is not language specific.
//Codes
export const F_CODE = 'KeyF';
